import { create } from 'zustand';
import type { User } from '../api/models';

export const FEATURE_ALIGNMENT = 'alignment';
export const FEATURE_ADVANCED_SENSORS = 'advanced_sensors';

export const DEFAULT_FEATURES: Record<string, boolean> = {
  [FEATURE_ALIGNMENT]: false,
  [FEATURE_ADVANCED_SENSORS]: false,
};

export const BASE_SENSOR_TYPES = ['M8', 'LR', 'M1', 'HD', 'Dome'] as const;
export const ADVANCED_SENSOR_TYPES = ['Rotating', 'MEMS', 'New Dome'] as const;

export const getAvailableSensorTypes = (advancedSensorsEnabled: boolean): string[] => (
  advancedSensorsEnabled
    ? [...BASE_SENSOR_TYPES, ...ADVANCED_SENSOR_TYPES]
    : [...BASE_SENSOR_TYPES]
);

interface UserState {
  currentUser: User | null;
  features: Record<string, boolean>;
  setCurrentUser: (user: User | null) => void;
  clearCurrentUser: () => void;
  hasFeature: (feature: string) => boolean;
}

export const useUserStore = create<UserState>((set, get) => ({
  currentUser: null,
  features: { ...DEFAULT_FEATURES },
  setCurrentUser: (user) => set({
    currentUser: user,
    features: user?.features ?? { ...DEFAULT_FEATURES },
  }),
  clearCurrentUser: () => set({
    currentUser: null,
    features: { ...DEFAULT_FEATURES },
  }),
  hasFeature: (feature) => Boolean(get().features[feature]),
}));
